import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TDropDownDesktop } from '../models';

export const DropDownDesktop: FC<TDropDownDesktop> = ({
    CommonLink,
    dataTestId,
    dropDownData,
    styles,
}) => {
    return (
        <>
            <div className={cn(styles.triangle)} />
            <ul className={cn(styles.dropDownBox)} data-test-id={dataTestId}>
                {dropDownData?.map(({ analytics, key, link, title }) => (
                    <li key={`${title}-${key}`}>
                        <CommonLink
                            key={key}
                            analytics={analytics}
                            className={cn(styles.dropDownItem)}
                            link={link}
                        >
                            {title}
                        </CommonLink>
                    </li>
                ))}
            </ul>
        </>
    );
};
